import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from "@angular/router";
import { Observable, of, EMPTY } from "rxjs";
import { mergeMap, take } from "rxjs/operators";
import { ORGANISER_DASHBOARD } from "src/app/app-routing.module";
import { RequestService } from "@services";
import { Organiser } from "@model";

export const OrganizerRequestReslover: ResolveFn<Observable<Organiser | null> |
  Promise<Organiser> | Organiser> =
  (route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    requestService: RequestService = inject(RequestService),
    router: Router = inject(Router)): Observable<Organiser | null> |
    Promise<Organiser> | Organiser => {
    let requestId = route.queryParams['requestId'];
    if (!requestId) {
      return of(requestId);
    } else {
      return requestService.fetchRequestById(
        +requestId, false)
        .pipe(
          take(1),
          mergeMap((res: Organiser | null) => {
            if (res) {
              return of(res);
            } else {
              router.navigate([ORGANISER_DASHBOARD]);
              return EMPTY;
            }
          })
        );
    }
  }
